import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import IGKDS from "../../../assets/img/SolutionsIcons/AgilysysIGKDS.svg";
import { Header } from "../../../components/Header";

const IGKDSFPage = () => {
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return (
      <div className="page splash IGKDSFPage">
        <div className="page-title">
          <img src={IGKDS} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            An integrated kitchen display system to manage kitchen orders. The
            Expo Display shows all orders for the kitchen, allowing an expediter
            to control the flow of orders and preparation times, while an Order
            Status Display shows diners the status of their orders and which
            can be shown in an ADA format.{"\n\n"}
          </div>
          <div className="std-text">
            For IG OnDemand customers, KDS can also be deployed in the cloud
            with support for multiple KDS stations, routing, scheduled orders, a
            queue tab and sending an SMS message when orders are bumped. The
            result is a seamless order flow from order taking to kitchen
            management and diner notification.
          </div>
        </div>
        <div
          className="play-video"
          onClick={() => {
            _logEvent("click", "Solutions - IG KDS", "Play Video");
            addFlow("Play Video");
            setShowVideo(true);
          }}
        >
          <PlayTriangle />
          Play Video
        </div>
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGKitchen1.png"
          }
          alt=""
        />
        <Popup
          showPopup={showVideo}
          setShowPopup={() => setShowVideo(false)}
          disableOffClick={true}
        >
          <>
            {showVideo && (
              <video
                autoPlay
                controls
                src={
                  "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveIGKDS.mp4"
                }
              />
            )}
          </>
        </Popup>
      </div>
    );
}

export default IGKDSFPage;